import React from 'react';
import PropTypes from 'prop-types';

import {
  Flex,
  Tooltip,
  Checkbox,
  FormHeading
} from '@sopranodesign/pulse-components';
import { TemplatingTextInput } from '@sopranodesign/pulse-templating';

import { useButtons } from '../../../../hooks';
import ExpiresTooltip from '../../../ExpiresTooltip';

const MailtoInput = ({
  content,
  index,
  rtl = 'ltr'
}) => {
  const { handleButtonChange } = useButtons();

  return (
    <Flex col ySpace fat>
      <FormHeading>Mail To</FormHeading>
      <TemplatingTextInput
        rtl={rtl}
        aria-label={`mailto-label-${index + 1}`}
        value={content.label}
        placeholder="Send Email"
        onChange={value => {
          handleButtonChange(index, 'label', value);
        }}
      />
      <Flex col>
        <TemplatingTextInput
          aria-label={`mailto-action-${index + 1}`}
          value={content.action}
          placeholder="name@example.com,second@example.com"
          onChange={value => {
            handleButtonChange(index, 'action', value);
          }}
        />
      </Flex>
      <Flex center>
        <TemplatingTextInput
          rtl={rtl}
          aria-label={`mailto-linkback-${index + 1}`}
          value={content.linkback}
          placeholder="The email was sent"
          onChange={value => {
            handleButtonChange(index, 'linkback', value);
          }}
        />
        <Tooltip
          position={Tooltip.POSITIONS.TOP}
          tooltip={
            <Tooltip.Content>
              This optional postback text can be used to trigger a new step when
              the user clicks the button to perform an action.
            </Tooltip.Content>
          }
        >
          <Tooltip.Icon>?</Tooltip.Icon>
        </Tooltip>
      </Flex>
      <Flex>
        <Checkbox
          aria-label={`mailto-expires-${index + 1}`}
          checked={content.linkback ? content.expires : false}
          disabled={!content.linkback}
          onChange={() => {
            handleButtonChange(index, 'expires', !content.expires);
          }}
          label="Disable on reply"
        />
        <ExpiresTooltip />
      </Flex>
    </Flex>
  );
};

MailtoInput.propTypes = {
  rtl: PropTypes.oneOf(['rtl', 'ltr']),
  content: {
    label: PropTypes.string.isRequired,
    action: PropTypes.string.isRequired,
    linkback: PropTypes.string.isRequired,
    expires: PropTypes.bool
  },
  index: PropTypes.number.isRequired
};

export default MailtoInput;
